import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import DynamicTable from "src/components/table";
import {
  columntype,
  dataLocalStorage,
  getLocalStorage,
  inputType,
  isValidArray,
} from "src/helper/publicFunction";
import {
  ManageSections,
  DeleteSections,
  EditSections,
  GetSections,
} from "./actions";
import DynamicModal from "src/components/modal/DynamicModal";
import * as Yup from "yup";
import { CommonAlert } from "src/components/alert/CommonAlert";

const Sections = () => {
  const dispatch = useDispatch();
  const Commonalert = CommonAlert();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingEditdatatype, setloadingEditdatatype] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [array, setarray] = useState([]);
  const [values, setvalues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [data, setData] = useState([]);
  const [TotalData, setTotalData] = useState(0);
  
  const privilegeId = "8"; 
  let dataPrivileges = getLocalStorage(dataLocalStorage.privileges);
  
  const Schema = Yup.object().shape({
    name: Yup.string().trim().required("Name is required"),
  });

  const GetData = () => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetSections({
        callback: (response) => {
          const responseData = response?.data;
          
          if (responseData && typeof responseData === 'object' && !Array.isArray(responseData)) {
            setData([responseData]);
            setTotalData(1);
          } else if (isValidArray(responseData)) {
            setData(responseData);
            setTotalData(responseData.length);
          } else {
            setData([]);
            setTotalData(0);
          }
          setLoadingData(false);
        },
      })
    );
    
    if (array.length === 0) {
      setarray([
        {
          failed: "id",
          type: inputType.text,
          title: "id",
          placeholder: "",
          fullwidth: true,
          customdesign: { display: "none" },
        },
        {
          failed: "name",
          type: inputType.text,
          title: "Name",
          placeholder: "Enter name",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "age_range",
          type: inputType.text,
          title: "Age Range",
          placeholder: "Enter age range (e.g., 7-11)",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "description",
          type: inputType.textarea,
          title: "Description",
          placeholder: "Enter description",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "color_code",
          type: inputType.color,
          title: "Color Code",
          placeholder: "Select color",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "image",
          type: inputType.image,
          title: "Image (Optional)",
          placeholder: "Upload image",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "display_order",
          type: inputType.number,
          title: "Display Order",
          placeholder: "Enter display order",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "is_active",
          type: inputType.checkbox,
          title: "Is Active",
          placeholder: "",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
      ]);
    }
  };

  useEffect(() => {
    GetData();
  }, [page, rowsPerPage, search]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.text, name: "name" },
    { type: columntype.text, name: "age_range" },
    { type: columntype.text, name: "description", isSmall: "true" },
    { type: columntype.text, name: "color_code" },
    { 
      type: columntype.image, 
      name: "image",
      options: {
        width: 100,
        height: 100
      }
    },
    { type: columntype.text, name: "display_order" },
    { type: columntype.boolean, name: "is_active" },
  ];

  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "ID",
      withSort: true,
    },
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "Name",
      withSort: false,
    },
    {
      id: "age_range",
      numeric: false,
      disablePadding: false,
      label: "Age Range",
      withSort: false,
    },
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      label: "Description",
      withSort: false,
    },
    {
      id: "color_code",
      numeric: false,
      disablePadding: false,
      label: "Color Code",
      withSort: false,
    },
    {
      id: "image",
      numeric: false,
      disablePadding: false,
      label: "Image",
      withSort: false,
    },
    {
      id: "display_order",
      numeric: false,
      disablePadding: false,
      label: "Display Order",
      withSort: false,
    },
    {
      id: "is_active",
      numeric: false,
      disablePadding: false,
      label: "Is Active",
      withSort: false,
    },
    (dataPrivileges[privilegeId]?.access_edit == 1 ||
      dataPrivileges[privilegeId]?.access_delete == 1) && {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Actions",
      withSort: false,
    },
  ];
  
  const List = [
    dataPrivileges[privilegeId]?.access_delete == 1 && {
      name: "Delete",
      function: async (row) => {
        if (row) {
          Commonalert.show({
            title: `Delete ${row?.name ?? "this item"}?`,
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteSections({
                      callback: () => GetData(),
                      id: [row?.id],
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }
      },
    },
    dataPrivileges[privilegeId]?.access_edit == 1 && {
      name: "Edit",
      function: async (data) => {
        setEditMode(true);
        // Preserve image URL when editing
        const editValues = {
          ...data,
          image_url: data.image || data.image_url, // Store original image URL
        };
        setvalues(editValues);
        setShowModal(true);
      },
    },
  ];

  const updateDataApi = ({ row, failedName, newData }) => {
    setloadingEditdatatype(`${row?.id}-${failedName}`);
    dispatch(
      EditSections({
        id: row?.id,
        dataFailed: newData,
        nameFailed: failedName,
        callback: () => {
          updateDataLocal({ id: row.id, failedName, newData });
          GetData();
        },
      })
    );
  };

  const updateDataLocal = ({ id, failedName, newData }) => {
    setData((prevData) => 
      prevData.map(item => 
        item.id === id ? {...item, [failedName]: newData} : item
      )
    );
    setloadingEditdatatype("");
  };

  return (
    <>
      <DynamicTable
        handleSearch={setSearch}
        onRequestSort={(tableName, type) => tableName && type && GetData({ tableName, type })}
        onPressDelete={(ListIds) => {
          Commonalert.show({
            title: "Confirm Delete",
            message: `Delete ${ListIds.length} item(s)?`,
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteSections({
                      callback: () => GetData(),
                      id: ListIds,
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }}
        onPressItem={() => {}}
        onPressAnyAction={updateDataApi}
        onPressAdd={() => {
          setvalues({});
          setEditMode(false);
          setShowModal(true);
        }}
        items={data}
        columns={columns}
        headCells={headCells}
        page={page}
        setPage={setPage}
        selected={selected}
        setSelected={setSelected}
        search={search}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        Listdropdown={List}
        withOption={true}
        loadingData={loadingData}
        rowsPerPageOptions={[5, 10, 25, 50]}
        totalItem={TotalData}
        loadingEditdatatype={loadingEditdatatype}
        withAddButton={dataPrivileges[privilegeId]?.access_write == 1}
        withDeleteItem={dataPrivileges[privilegeId]?.access_delete == 1}
        withEditItem={dataPrivileges[privilegeId]?.access_edit == 1}
        withPagination={false}
        withSearch={false}
      />
      
      {showModal && (
        <DynamicModal
          show={showModal}
          setShow={setShowModal}
          faileds={array}
          values={values}
          title={"Scout Sections"}
          editMode={editMode}
          description={editMode ? "Edit Section" : "Add New Section"}
          buttonTitle={editMode ? "Update" : "Create"}
          onSubmit={(values) => {
            dispatch(
              ManageSections({
                editMode,
                values,
                callback: (res) => {
                  if (res) {
                    setShowModal(false);
                    GetData();
                  }
                },
              })
            );
          }}
          Schema={Schema}
        />
      )}
    </>
  );
};

export default Sections;

